export default {
  Trips: "Trips",
  TripsDetail: "TripsDetail",
  TripsInvoice: "TripsInvoice",
};
